var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-main",
    { staticClass: "pa-2", attrs: { fluid: "" } },
    [
      _c("h1", [_vm._v("Roles")]),
      _vm._v(" "),
      _c(
        "v-row",
        [
          _c(
            "v-dialog",
            {
              attrs: { persistent: "", "max-width": "600px" },
              on: {
                keydown: function($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "esc", 27, $event.key, [
                      "Esc",
                      "Escape"
                    ])
                  ) {
                    return null
                  }
                  _vm.dialog = false
                }
              },
              scopedSlots: _vm._u([
                {
                  key: "activator",
                  fn: function(ref) {
                    var on = ref.on
                    return [
                      _c(
                        "v-btn",
                        _vm._g({ attrs: { color: "primary", dark: "" } }, on),
                        [_vm._v("Add new Role")]
                      )
                    ]
                  }
                }
              ]),
              model: {
                value: _vm.dialog,
                callback: function($$v) {
                  _vm.dialog = $$v
                },
                expression: "dialog"
              }
            },
            [
              _vm._v(" "),
              _c(
                "v-card",
                { attrs: { color: "lighten-1" } },
                [
                  _c(
                    "v-toolbar",
                    [
                      _c("v-toolbar-title", [
                        _c("span", { staticClass: "headline" }, [
                          _vm._v(_vm._s(_vm.formTitle))
                        ])
                      ]),
                      _vm._v(" "),
                      _c("v-spacer")
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-card-text",
                    [
                      _c(
                        "v-container",
                        [
                          _c(
                            "v-row",
                            [
                              _c(
                                "v-form",
                                {
                                  ref: "form",
                                  staticClass: "row",
                                  model: {
                                    value: _vm.valid,
                                    callback: function($$v) {
                                      _vm.valid = $$v
                                    },
                                    expression: "valid"
                                  }
                                },
                                [
                                  _c(
                                    "v-col",
                                    { attrs: { cols: "12", md: "12" } },
                                    [
                                      _c("v-text-field", {
                                        attrs: {
                                          label: "title",
                                          rules: _vm.nameRules,
                                          required: ""
                                        },
                                        model: {
                                          value: _vm.editedItem.title,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.editedItem,
                                              "title",
                                              $$v
                                            )
                                          },
                                          expression: "editedItem.title"
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("v-select", {
                                        attrs: {
                                          items: _vm.ability,
                                          label: "Abilities",
                                          multiple: "",
                                          chips: "",
                                          hint:
                                            "Select the Abilities you want for this role",
                                          "persistent-hint": ""
                                        },
                                        model: {
                                          value: _vm.editedItem.rules,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.editedItem,
                                              "rules",
                                              $$v
                                            )
                                          },
                                          expression: "editedItem.rules"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-card-actions",
                    [
                      _c("v-spacer"),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          attrs: { color: "blue darken-1", text: "" },
                          on: { click: _vm.close }
                        },
                        [_vm._v("Cancel")]
                      ),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            color: "blue darken-1",
                            type: "submit",
                            disabled: !_vm.valid
                          },
                          on: { click: _vm.save }
                        },
                        [_vm._v("Save")]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("v-data-table", {
        staticClass: "elevation-1",
        attrs: { headers: _vm.headers, items: _vm.roles, "items-per-page": 10 },
        scopedSlots: _vm._u([
          {
            key: "item.actions",
            fn: function(ref) {
              var item = ref.item
              return [
                item.name !== "admin"
                  ? _c(
                      "v-btn",
                      {
                        attrs: { icon: "", small: "" },
                        on: {
                          click: function($event) {
                            return _vm.edit(item)
                          }
                        }
                      },
                      [
                        _c("v-icon", { attrs: { center: "" } }, [
                          _vm._v("mdi-pencil")
                        ])
                      ],
                      1
                    )
                  : _vm._e()
              ]
            }
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }